module.exports = __webpack_public_path__ + "static/img/10.9b6c7ee.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/front/threeD/12/10.png
// module id = TlXj
// module chunks = 2